import { useMainSelector } from '../useMainSelector';

export const useMfaSettings = () => {
  const {
    user: { currentUser },
  } = useMainSelector();

  return {
    qrCode: currentUser?.mfaData?.qrCode,
    key: currentUser?.mfaData?.key,
    name: currentUser?.mfaData?.name,
  };
};
